/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { inject, InjectionToken } from '@angular/core';


import { BREAKPOINT } from './tokens/breakpoint-token';
import { LAYOUT_CONFIG } from './tokens/library-config';
import { DEFAULT_BREAKPOINTS } from './break-point';
import { ORIENTATION_BREAKPOINTS } from './orientation-break-point';
import { mergeByAlias } from './break-point-tools';
import { BreakPoint } from './tokens/breakPoint';

/**
 *  Injection token unique to the flex-layout library.
 *  Use this token when build a custom provider (see below).
 */
export const BREAKPOINTS =
  new InjectionToken<BreakPoint[]>('Token (@angular/flex-layout) Breakpoints', {
    providedIn: 'root',
    factory: () => {
      const breakpoints: any = inject(BREAKPOINT);
      const layoutConfig = inject(LAYOUT_CONFIG);
      const bpFlattenArray: BreakPoint[] = [].concat.apply([], (breakpoints || [])
        .map((v: BreakPoint | BreakPoint[]) => Array.isArray(v) ? v : [v]));
      const builtIns = (layoutConfig.disableDefaultBps ? [] : DEFAULT_BREAKPOINTS)
        .concat(layoutConfig.addOrientationBps ? ORIENTATION_BREAKPOINTS : []);

      return mergeByAlias(builtIns, bpFlattenArray);
    }
  });